// URL/filter-state helpers, adapted from the Unit List precedent
// (pages/Inventory/Unit/List/index.js). Filter state keys are the exact
// backend query param names (search/type/payment_status/phase/year/ordering)
// so no extra translation layer is needed between UI state, the URL query
// string, and the API params sent to getContracts/getContractStats.

export const DEFAULT_ORDERING = "-pvc_date";

const STRING_PARAMS = ["search", "type", "payment_status", "ordering"];
const NUMERIC_PARAMS = ["phase", "year"];

export const readParamsFromSearch = (searchParams) => {
  const params = { ordering: DEFAULT_ORDERING };
  STRING_PARAMS.forEach((k) => {
    const v = searchParams.get(k);
    if (v) params[k] = v;
  });
  NUMERIC_PARAMS.forEach((k) => {
    const v = searchParams.get(k);
    if (v != null && v !== "" && !Number.isNaN(Number(v))) params[k] = Number(v);
  });
  return params;
};

export const buildQueryString = (filterParams, page) => {
  const next = new URLSearchParams();
  if (page > 1) next.set("page", String(page));
  Object.entries(filterParams || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (k === "ordering" && v === DEFAULT_ORDERING) return;
    next.set(k, String(v));
  });
  return next;
};

export const paramsEqual = (a, b) => {
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  return ka.length === kb.length && ka.every((k) => a[k] === b[k]);
};

// Sortable table-column id -> backend `ordering` field name. "next_payment"
// is a sentinel the backend special-cases (see ContractViewSet.filter_queryset)
// rather than a raw column, since both SETTLED and UNSCHEDULED contracts
// share next_payment_date=NULL.
export const ORDERING_FIELD_MAP = {
  pvc_number: "pvc_number",
  client: "client_display_name",
  next_payment: "next_payment",
  pvc_date: "pvc_date",
};

export const parseOrdering = (ordering) => {
  if (!ordering) return { field: null, dir: "asc" };
  const dir = ordering.startsWith("-") ? "desc" : "asc";
  const raw = dir === "desc" ? ordering.slice(1) : ordering;
  const field = Object.keys(ORDERING_FIELD_MAP).find((k) => ORDERING_FIELD_MAP[k] === raw) || null;
  return { field, dir };
};

export const buildOrdering = (field, dir) => {
  const backendField = ORDERING_FIELD_MAP[field] || field;
  return dir === "desc" ? `-${backendField}` : backendField;
};
